import { render, staticRenderFns } from "./MemberEmailChange.vue?vue&type=template&id=64751e44"
import script from "./MemberEmailChange.vue?vue&type=script&lang=js"
export * from "./MemberEmailChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports